import classNames from "classnames";
import React from "react";
import { c } from "ttag";

import { Image } from "../../../common/Image";
import { IProduct } from "../../../models/catalogue.interfaces";

interface IProps {
    rootProduct: IProduct;
    isSelected: boolean;
    onClick: () => void;
}

export const GiftThumbnail = (props: IProps): React.JSX.Element | null => {
    const image = props.rootProduct.images.filter((img) => {
        return img.role === "Product Tile";
    })[0];
    if (!image) {
        console.error(
            `Tile image is missing for product ${props.rootProduct.title}`,
        );
        return null;
    }
    const thumbnailClasses = classNames({
        "gift-thumbnail": true,
        "gift-thumbnail--selected": props.isSelected,
    });
    const altText = c("GiftThumbnail").t`Select ${props.rootProduct.title}`;
    return (
        <li className={thumbnailClasses}>
            <button type="button" title={altText} onClick={props.onClick}>
                <Image src={image.original} alt={altText} />
            </button>
        </li>
    );
};
